module.exports = __webpack_public_path__ + "media/images/pc/specials/common/event/event_consulting-1954a37593857ffb0212d26293558fd4.jpg";